<template>
  <div v-if="dialogBindRadish" class="dialog-serchRadish">
    <span class="closedialog" @click="dialogBindRadish = false">X</span>
    <div class="dialog-serchRadish-content-box">
      <!-- 搜索框上边的模板 -->
      <slot name="header"></slot>
      <div class="serch-company">
        <strong>请输入关键词，多个关键词之间请用空格空开</strong>
        <el-input v-model="bindRadishKeywords" size="mini" style="width:80%" @keyup.enter.native="serchRadish(bindRadishKeywords)"></el-input>
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="serchRadish(bindRadishKeywords)">搜索</div>
      </div>
      <div class="handle_btn_box">
        <div v-if="multipleSelection.length > 1" class="radish-btn radish-btn-primary radish-btn-small" style="float:left" @click="chooseMain">
          确认合并
        </div>
        <div v-if="multipleSelection.length > 1 && couldChooseMore" class="radish-btn radish-btn-primary radish-btn-small" style="float:left" @click="chooseAll">
          全部添加
        </div>
      </div>
      <el-alert v-if="couldMerge" title="勾选多个人选可进行多人添加或者合并操作" type="warning" style="flex:none;"> </el-alert>
      <el-table ref="multipleTable" v-loading="serchRadishLoading" :data="serchRadishResult" size="mini" style="width: 100%;flex:auto;" max-height="300" @selection-change="handleSelectionChange">
        <el-table-column v-if="couldMerge" type="selection" width="50"></el-table-column>
        <el-table-column prop="操作" label="操作" width="60px">
          <template slot-scope="scope">
            <span class="drawer-link" @click="chooseThisRadish(scope.row)">{{ chooseBtnText }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="姓名" label="姓名" width="100px">
          <template slot-scope="scope">
            <span class="drawer-link" @click="showRadish(scope.row)">{{ scope.row.姓名 }}</span>
            <div style="color:#aaa">{{ scope.row.手机 }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="公司" label="公司" width="100px"></el-table-column>
        <el-table-column prop="部门" label="部门" width="100px"></el-table-column>
        <el-table-column prop="目前职位" label="目前职位" width="100px"></el-table-column>
        <el-table-column prop="职级" label="职级" width="50px"></el-table-column>
        <el-table-column prop="职能模块" label="职能模块" width="140px">
          <template slot-scope="scope">
            <div>
              <el-tag v-for="tag in scope.row.职能模块" :key="tag" size="mini">{{ tag }}</el-tag>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="couldInsert && !toInsertRadish" class="dialog-serchRadish-footer" style="flex:none;">
        <!-- <el-button @click="insertRadish" size="mini" type="primary">点击新增人选</el-button> -->
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="insertRadish">点击新增人选</div>
      </div>
      <div v-if="couldInsert && toInsertRadish" class="dialog-serchRadish-insertRadish" style="flex:none;">
        <div class="flex-row justify-between item-center">
          <span class="propject_detail_info_table_cell col-2">
            <el-input v-model="newRadish.姓名" placeholder="姓名" size="mini" />
          </span>
          <span class="propject_detail_info_table_cell col-2">
            <el-input v-model="newRadish.手机" placeholder="手机" size="mini" @blur="duplicateRadish" />
          </span>
          <span class="propject_detail_info_table_cell col-2">
            <el-input v-model="newRadish.目前职位" placeholder="目前职位" size="mini" />
          </span>
          <span class="propject_detail_info_table_cell col-2">
            <el-input v-model="newRadish.公司" placeholder="公司" size="mini" />
          </span>
          <span class="propject_detail_info_table_cell col-2">
            <el-select v-model="newRadish.职级" filterable placeholder="职级" size="mini">
              <el-option v-for="(val, key) in rankOption" :key="key" :label="`${key}:${val}`" :value="key"></el-option>
            </el-select>
          </span>
          <span class="propject_detail_info_table_cell col-2">
            <el-select v-model="newRadish.职能模块" placeholder="职能模块" filterable multiple size="mini">
              <el-option v-for="item in categories" :key="item.名称" :value="item.名称"></el-option>
            </el-select>
          </span>
        </div>
        <div class="flex-row item-center">
          <span class="propject_detail_info_table_cell">
            <el-input v-model="newRadish.邮箱" placeholder="邮箱" size="mini" />
          </span>
          <span class="propject_detail_info_table_cell">
            <el-input v-model="newRadish.座机" placeholder="座机" size="mini" />
          </span>
        </div>
        <div class="propject_detail_info_table_cell">
          <el-input v-model="newRadish.简介" placeholder="简介" type="textarea" size="mini" />
        </div>
        <div style="overflow:hidden">
          <div class="radish-btn radish-btn-primary radish-btn-small" style="float:right;margin-left:8px;" @click="cancelInsertRadish">
            取消
          </div>
          <div class="radish-btn radish-btn-primary radish-btn-small" style="float:right" @click="confirmInsertRadish">
            新建并选择
          </div>
          <!-- <el-button @click="cancelInsertRadish" style="float:right;margin-left:8px;" size="mini" type="primary">取消</el-button>
          <el-button @click="confirmInsertRadish" style="float:right" size="mini" type="primary">新建并选择</el-button> -->
        </div>
      </div>
      <!-- 选择合并时的主数据 -->
      <el-dialog title="选择主要数据" :visible.sync="chooseMainDialogVisible" :close-on-click-modal="false" :modal="false" width="500px">
        <el-radio-group v-model="radio">
          <el-radio v-for="item in multipleSelection" :key="item._id" style="margin-left:0;" :label="item._id">
            <span class="dialog-span drawer-link" @click="showRadish(item)">{{ item.姓名 }}</span>
            <span class="dialog-span" style="color:#aaa">{{ item.手机 }}</span>
            <span class="dialog-span">{{ item.公司 }}</span> <span class="dialog-span">{{ item.部门 }}</span>
            <span class="dialog-span">{{ item.目前职位 }}</span> <span class="dialog-span">{{ item.职级 }}</span>
            <span class="dialog-span">
              <el-tag v-for="tag in item.职能模块" :key="tag" size="mini">{{ tag }}</el-tag>
            </span>
          </el-radio>
        </el-radio-group>
        <span slot="footer" class="dialog-footer">
          <div class="radish-btn radish-btn-primary radish-btn-small" @click="chooseMainDialogVisible = false">
            取 消
          </div>
          <div class="radish-btn radish-btn-primary radish-btn-small" @click="confirmMerge">确 定</div>
          <!-- <el-button size="mini" @click="chooseMainDialogVisible = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="confirmMerge">确 定</el-button> -->
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import * as fixedvariant from '../../statistics/variant/fixedvariant'

export default {
  props: {
    couldInsert: { type: Boolean, default: false },
    couldChooseMore: { type: Boolean, default: false },
    sort: { type: String, default: '' },
    chooseBtnText: { type: String, default: '选择' },
    defaultCompany: { type: String, default: '' },
  },
  data() {
    return {
      rankOption: fixedvariant.职级2描述,
      dialogBindRadish: false,
      bindRadishKeywords: '',
      serchRadishLoading: false,
      serchRadishResult: [],
      toInsertRadish: false,
      newRadish: {},
      multipleSelection: [],
      radio: '',
      introductionRadish: {},
      chooseMainDialogVisible: false,
    }
  },
  computed: {
    couldMerge() {
      return this.serchRadishResult.length > 1
    },
    categories() {
      return app.categories
    },
  },
  async mounted() {
    this.domdrag()
    if (!app.categories) {
      await app.getCats()
    }
  },
  methods: {
    init() {
      this.radio = ''
      this.multipleSelection = []
      this.toInsertRadish = false
      this.chooseMainDialogVisible = false
    },
    chooseMain() {
      this.chooseMainDialogVisible = true
    },
    chooseAll() {
      this.$emit('chooseMore', this.multipleSelection)
      this.dialogBindRadish = false
    },
    async confirmMerge() {
      if (this.radio === '') return this.$message('请选择以哪条数据为主')

      const first = this.radio
      const second = this.multipleSelection.map((v) => v._id).filter((v) => v !== first)

      const res = await app.service('radish').mergeMult({ id: first, first, second })
      if (res.status === 'success') {
        const radish = this.multipleSelection.filter((v) => v._id === first)
        this.$emit('choose', radish[0])
        this.dialogBindRadish = false
      } else this.$message(res.msg)
    },
    showMerge() {
      this.$refs.multipleTable.clearSelection()
      this.multipleSelection = []
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    open(radish = {}, defaultData) {
      this.init()
      this.dialogBindRadish = true
      this.introductionRadish = radish || {}
      if (defaultData) {
        this.serchRadishResult = this.sortData(defaultData)
      } else if (radish.姓名) {
        this.serchRadish(radish.姓名)
      }
    },
    sortData(arr) {
      const srotArr = arr
      if (this.sort) {
        const reg = new RegExp(this.sort, 'g')
        const index = []
        srotArr.forEach((radish, ind) => {
          if (reg.test(radish.公司)) index.push(ind)
        })
        if (index.length !== 0) {
          index.forEach((ind) => {
            const item = srotArr.splice(ind, 1)
            srotArr.splice(0, 0, item[0])
          })
        }
      }
      return srotArr
    },
    insertRadish() {
      this.toInsertRadish = true
      const { introductionRadish } = this
      this.newRadish = {
        公司: introductionRadish.公司,
        姓名: introductionRadish.姓名,
      }
      if (this.defaultCompany) this.$set(this.newRadish, '公司', this.defaultCompany)
      const keys = [
        '姓名',
        '部门',
        '简介',
        '二级部门',
        '手机',
        '目前职位',
        '座机',
        '地域',
        '邮箱',
        '其他',
        '性别',
        '职能模块',
      ]
      keys.forEach((field) => {
        if (introductionRadish[field]) this.$set(this.newRadish, field, introductionRadish[field])
      })
      this.duplicateRadish()
    },
    async confirmInsertRadish() {
      const radish = this.newRadish
      if (!radish.姓名) {
        return this.$message.error('请输入姓名')
      }
      if (radish.手机 && radish.couldInsert === false) {
        return this.$message.error('手机号已存在，无法添加')
      }

      delete radish.couldInsert
      radish.from = 'serchRadishDialog'
      const res = await window.app.service('radish').insert(radish)
      if (res.status == 'success') {
        this.$message.success(`添加成功`)
        const newRadish = Object.assign({ _id: res.data.id }, radish)
        newRadish.isNew = true
        this.$emit('choose', newRadish)
        this.toInsertRadish = false
        this.dialogBindRadish = false
      } else {
        this.$message.error(`${res.msg}`)
      }
    },
    cancelInsertRadish() {
      this.toInsertRadish = false
    },
    async duplicateRadish() {
      const radish = this.newRadish
      if (!radish.手机) return
      const res = await app.service('company').gethrmessage(radish.手机)
      if (res.status === 201) this.newRadish.couldInsert = true
      else if (res.status === 200) {
        this.newRadish.couldInsert = false
        this.$message('该手机号已存在')
        this.serchRadish(radish.手机)
        this.toInsertRadish = false
      }
    },
    showRadish(radish) {
      window.open(`${window.frontend}/#/radish-detail-blank/${radish._id}`, '_blank')
    },
    async serchRadish(keywords) {
      this.serchRadishLoading = true
      // const searchKeyWords = this.defaultCompany ? `${keywords} ${this.defaultCompany}` : keywords
      const searchKeyWords = keywords
      const res = await app.service('misc').searchEs({
        type: '人选',
        keywords: searchKeyWords,
        fields: ['姓名', '公司', '部门', '职能模块', '手机'],
        and: true,
      })

      this.serchRadishLoading = false
      if (res.status == 'success') {
        if (res.data.length == 0) {
          this.$message.info('没有符合条件的结果')
          this.serchRadishResult = []
        } else {
          this.serchRadishResult = this.sortData(res.data)
        }
        this.$nextTick((_) => {
          this.domdrag()
        })
      } else {
        this.$message.error(res.msg)
      }
    },
    domdrag() {
      let startX, startY, clientX, clientY
      let dom
      let isDrag = false
      document.addEventListener('mousedown', (e) => {
        if (typeof e.target.className !== 'object' && e.target.className.indexOf('dialog-serchRadish') !== -1) {
          e.preventDefault()
          dom = e.target
          dom.style.zIndex = app.root.dragindex++
          startX = dom.offsetLeft
          startY = dom.offsetTop
          clientX = e.clientX
          clientY = e.clientY
          isDrag = true
        }
      })
      document.addEventListener('mousemove', (e) => {
        if (isDrag) {
          e.preventDefault()
          dom.style.left = `${e.clientX - clientX + startX}px`
          dom.style.top = `${e.clientY - clientY + startY}px`
        }
      })
      document.addEventListener('mouseup', (e) => {
        isDrag = false
      })
    },
    chooseThisRadish(radish) {
      if (this.multipleSelection.length > 1) {
        this.chooseMain()
      } else {
        this.$emit('choose', radish)
        this.dialogBindRadish = false
      }
    },
  },
}
</script>
<style scoped>
.table-box {
  border: 1px solid #eee;
  border-radius: 5px;
  padding: 8px;
  background-color: #f5f5f5;
}
.serch-company {
  padding: 8px 0;
  flex:none;
}
.dialog-serchRadish {
  position: fixed;
  background-color: #fff;
  border-radius: 6px;
  width: 690px;
  right: 0;
  left: calc(50vw - 320px);
  top: 150px;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 2px rgba(232, 237, 250, 0.5);
  padding: 30px 17px;
  z-index: 1600 !important;
  max-height: calc(100vh - 170px);
  display: flex;
}
.dialog-serchRadish-content-box {
      flex: auto;
    overflow: auto;
  display: flex;
  flex-direction: column;
}
.closedialog {
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
  user-select: none;
  font-size: 18px;
  color: #e03838;
}
.handle_btn_box {
  padding: 6px 0;
  flex:none;
}
.dialog-span {
  padding: 0 4px;
  color: #606266;
}
</style>
